
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import { TruckEventResource } from "../../../models/api/trucks/events";

const truckModuleState = getModule(TruckModule);

@Component({ name: modals.truckAuditLogModal })
export default class TruckAuditLogModal extends Mixins(mixin) {
  events: TruckEventResource[] = null;
  loading: boolean = true;

  get hasEvents() {
    return this.events != null && this.events.length > 0;
  }

  async load() {
    this.show();

    let selectedTruck = this.selectedItem;

    const items = await truckModuleState.getTruckEvents(selectedTruck.id);

    this.events = items;
    this.loading = false;
  }

  reset() {
    this.events = null;
    this.loading = true;
  }
}
